import React, { useEffect, useState } from 'react'
import EmployerDashboardNav from '../../employer/EmployerDashboardNav'
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Modal } from "bootstrap"
import Breadcrumb from '../../Breadcrumb';

export const PostedJobs = ({ onJobClick = job => { }, actionFlag = true, selectedJobProp = null }) => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [jobsPerPage] = useState(6);
  const [selectedJob, setSelectedJob] = useState(null);
  const [confirmationModal, setConfirmationModal] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [modalStatus, setModalStatus] = useState('confirm');
  const [modalMessage, setModalMessage] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');

  const companyId = localStorage.getItem('companyId');
  const navigate = useNavigate();

  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const filteredJobs = jobs.filter(job => {
    const validStatus = (job.job_status === 1 || job.job_status === 2);
    const statusMatch = (
      filterStatus === "all" ||
      filterStatus === job.job_type.toLowerCase() ||
      (filterStatus === "1" && job.job_status === 1) ||
      (filterStatus === "0" && job.job_status === 2)
    );
    const searchMatch = (
      job.job_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      job.department.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return validStatus && statusMatch && searchMatch;
  });
  const currentJobs = filteredJobs.slice(indexOfFirstJob, indexOfLastJob);
  const totalPages = Math.ceil(filteredJobs.length / jobsPerPage);

  const formatter = new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
  });

  useEffect(() => {
    const modalElement = document.getElementById('confirmationModal');
    const modal = new Modal(modalElement, {
      backdrop: 'static',
      keyboard: false
    });
    setConfirmationModal(modal);
  }, []);

  const fetchJobs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}jobs/get-jobs-by-company`, {
        params: { companyId }
      });
      setJobs(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (job) => {
    setSelectedJob(job);
    setModalStatus('confirm');
    setModalMessage('');
    confirmationModal.show();
  };

  const handleDeleteJob = (job) => {
    setSelectedJob(job);
    setModalStatus('before-delete');
    setModalMessage('');
    confirmationModal.show();
  }

  const handleModalClose = () => {
    confirmationModal.hide();
    setTimeout(() => {
      setSelectedJob(null);
      setModalStatus('confirm');
      setModalMessage('');
      setIsProcessing(false);
    }, 300);
  };

  const deleteJob = async () => {
    if (!selectedJob) return;

    setIsProcessing(true);
    setModalStatus('processing');

    try {
      await axios.put(`${process.env.REACT_APP_API_URL}jobs/deletejob/${selectedJob.job_id}`)
      await fetchJobs();
      setModalStatus('success');
      setModalMessage(`Job successfully Deleted!`);

      setTimeout(handleModalClose, 1200);
    } catch (error) {
      console.log(error);
      setModalStatus('error');
      setModalMessage('An error occurred. Please try again.');
      setTimeout(handleModalClose, 1200);
    } finally {
      setIsProcessing(false);
    }
  }

  const activateOrDeactivate = async () => {
    if (!selectedJob) return;

    const userRole = localStorage.getItem('userType');
    const isActivateAction = selectedJob.job_status === 2;

    if (isActivateAction && userRole !== 'admin') {
      setModalStatus('error');
      setModalMessage('Only Admin can activate a job.');
      setTimeout(handleModalClose, 1500);
      return;
    }

    setIsProcessing(true);
    setModalStatus('processing');

    const url = isActivateAction
      ? `${process.env.REACT_APP_API_URL}jobs/activatejob/${selectedJob.job_id}`
      : `${process.env.REACT_APP_API_URL}jobs/deactivatejob/${selectedJob.job_id}`;

    try {
      await axios.put(url);
      await fetchJobs();

      setModalStatus('success');
      setModalMessage(`Job successfully ${isActivateAction ? 'activated' : 'deactivated'}!`);
      setTimeout(handleModalClose, 1200);
    } catch (error) {
      console.log(error);
      setModalStatus('error');
      setModalMessage('An error occurred. Please try again.');
      setTimeout(handleModalClose, 1200);
    } finally {
      setIsProcessing(false);
    }
  };

  const renderModalContent = () => {
    switch (modalStatus) {
      case 'processing':
        return (
          <div className="loading-spinner-container">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Processing...</span>
            </div>
            <p className="mt-3">Processing your request...</p>
          </div>
        );

      case 'success':
        return (
          <div className="text-center text-success">
            <i className="fas fa-check-circle fa-3x mb-3"></i>
            <p>{modalMessage}</p>
          </div>
        );

      case 'error':
        return (
          <div className="text-center text-danger">
            <i className="fas fa-exclamation-circle fa-3x mb-3"></i>
            <p>{modalMessage}</p>
          </div>
        );
      case "before-delete":
        return (
          <div className="text-center text-danger">
            <i className="fas fa-times fa-3x mb-3"></i>
            <p className="mb-0">
              Are you sure you want to delete this job?
            </p>
            <p className="fw-bold mt-2">"{selectedJob?.job_name}"?</p>
          </div>
        )
      case 'after-delete':
        return (
          <div className="text-center text-danger">
            <i className="fas fa-times fa-3x mb-3"></i>
            <p>{modalMessage}</p>
          </div>
        )
      default:
        return (
          <>
            <i className={`fas fa-${selectedJob?.job_status ? 'pause' : 'play'}-circle fa-3x mb-3 ${selectedJob?.job_status ? 'text-danger' : 'text-success'
              }`}></i>
            <p className="mb-0">
              Are you sure you want to {selectedJob?.job_status === 1 ? 'deactivate' : 'activate'} the job posting:
            </p>
            <p className="fw-bold mt-2">"{selectedJob?.job_name}"?</p>
          </>
        );
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <>
      <div className="col-lg fade-in">
        <div className="card job-table-card">
          <div className="card-header bg-white d-flex justify-content-between align-items-center py-3">
            <h5 className="mb-0 section-title g-2 d-flex align-items-center gap-2">
              <i className="fas fa-calendar-check text-primary"></i>
              <span className='m-5'>Job Management</span>
            </h5>
            <button className="btn btn-primary" onClick={fetchJobs}>
              <i className="fas fa-refresh me-2"></i>Refresh
            </button>
          </div>
          <div className="card-body">
            <div className="row mb-4">
              <div className="col-md-6">
                <div className="input-group">
                  <span className="input-group-text bg-light border-end-0">
                    <i className="fas fa-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0 ps-0 custom-input p-2"
                    placeholder="Search by Job Name, Department..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <select
                  className="form-select"
                  value={filterStatus}
                  onChange={(e) => {
                    setFilterStatus(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="all">All Statuses</option>
                  <option value="1">Active</option>
                  <option value="0">Not Active</option>
                </select>
              </div>
            </div>
            <div className="table-responsive">
              {loading ? (
                <div className="loading-container">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading jobs...</span>
                  </div>
                  <p className="mt-3">Loading jobs...</p>
                </div>
              ) : jobs.length > 0 ? (
                <div className="table-container">
                  <table className="table table-hover align-middle border-bottom animate__animated animate__fadeIn">
                    <thead className="bg-light">
                      <tr>
                        <th className="fw-medium">Job Info</th>
                        <th className="fw-medium">Type</th>
                        <th className="fw-medium">Status</th>
                        <th className="fw-medium">Start Date</th>
                        {actionFlag && <th className="fw-medium text-center">Actions</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {currentJobs.map((job) => {
                        if (job.job_status === 0) return;

                        return <tr key={job.job_id} className={` job-row${selectedJobProp?.job_id === job.job_id ? 'table-active' : ''}`}>
                          <td className="td-job-info p-3">
                            <div className="d-flex align-items-center">
                              <div>
                                <h6 className="mb-1">{job.job_name}</h6>
                                <div className="align-items-start">
                                  <div className="d-flex align-items-center me-0">
                                    <i className="far fa-briefcase me-1"></i>
                                    <span>{job.department}</span>
                                  </div>
                                  <div className="d-flex me-0 align-items-start">
                                    <i className="far fa-location-dot me-1"></i>
                                    <span>{job.city ? job.city : "Not Available"}</span>
                                  </div>
                                  <div className="d-flex me-0 align-items-start">
                                    <i className="far fa-calendar-alt me-1"></i>
                                    <span>{job.experience ? job.experience : "Not Available"}</span>
                                  </div>
                                  <div className="d-flex me-0 align-items-start">
                                    <i className="far fa-briefcase me-1"></i>
                                    <span>{({ wfh: 'Work From Home', hybrid: 'Hybrid', wfo: 'Work From Office' }[job.work_mode?.toLowerCase()] || job.work_mode || '-')}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="text-primary">
                            {job.job_type}
                          </td>
                          <td className="td-status">
                            <span className={`status-indicator ${job.job_status === 1 ? "active" : "inactive"}`}>
                              <span className="status-dot"></span>
                              {job.job_status === 1 ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td className="td-date">
                            <span className="date-text">
                              {formatter.format(new Date(job.post_date))}
                            </span>
                          </td>
                          <td>
                            <button
                              onClick={() => onJobClick(job)}
                              className="btn btn-action btn-view"
                            >
                              <i className="far fa-eye me-1"></i>
                              View
                            </button>
                          </td>
                          {actionFlag && <td>
                            <div className="action-buttons d-grid justify-content-center align-items-center">
                              <button
                                onClick={() => navigate("/job-details-page", { state: { job } })}
                                className="btn btn-action btn-view"
                              >
                                <i className="far fa-eye me-1"></i>
                                View
                              </button>
                              <button
                                onClick={() => handleStatusChange(job)}
                                className={`btn btn-action ${job.job_status === 1 ? "btn-deactivate" : "btn-activate"
                                  }`}
                              >
                                <i className={`far fa-${job.job_status === 1 ? 'pause' : 'play'} me-1`}></i>
                                {job.job_status === 1 ? "Deactivate" : "Activate"}
                              </button>
                              <button
                                onClick={() => navigate("/postjob", { state: { job, updateMode: true } })}
                                className="btn btn-action btn-edit"
                              >
                                <i className="far fa-edit me-1"></i>
                                Edit
                              </button>
                              <button
                                type="button"
                                className="btn btn-action btn-outline-danger"
                                onClick={() => handleDeleteJob(job)}
                              >
                                <i className="far fa-trash-alt me-1"></i>
                                Delete Job
                              </button>
                            </div>
                          </td>}

                        </tr>
                      })}
                    </tbody>
                  </table>

                  <div className="pagination-wrapper">
                    <div className="pagination-container">
                      <button
                        className="pagination-btn prev"
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        <i className="far fa-chevron-left me-1"></i>
                        Previous
                      </button>

                      <div className="page-numbers">
                        {pageNumbers.map(number => (
                          <button
                            key={number}
                            className={`page-number ${currentPage === number ? 'active' : ''}`}
                            onClick={() => paginate(number)}
                          >
                            {number}
                          </button>
                        ))}
                      </div>

                      <button
                        className="pagination-btn next"
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      >
                        Next
                        <i className="far fa-chevron-right ms-1"></i>
                      </button>
                    </div>

                    <div className="entries-info">
                      Showing {indexOfFirstJob + 1} to {Math.min(indexOfLastJob, filteredJobs.length)} of {filteredJobs.length} entries
                    </div>
                  </div>
                </div>

              ) : (
                <div className="empty-state">
                  <i className="far fa-folder-open fa-3x mb-3"></i>
                  <h5>No jobs available</h5>
                  <p className="text-muted">Start by posting your first job opening</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade custom-modal" id="confirmationModal" tabIndex="-1"
        aria-labelledby="confirmationModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <h5 className="modal-title" id="confirmationModalLabel">
                {selectedJob?.job_status === 1 ? 'Deactivate' : 'Activate'} Job
              </h5>
              {!isProcessing && modalStatus === 'confirm' && (
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleModalClose}
                  aria-label="Close"
                ></button>
              )}
            </div>
            <div className="modal-body text-center py-4">
              {renderModalContent()}
            </div>
            {modalStatus === 'confirm' && !isProcessing && (
              <div className="modal-footer border-top-0 justify-content-center">
                <button
                  type="button"
                  className="btn btn-outline-secondary px-4"
                  onClick={handleModalClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={`btn px-4 ${selectedJob?.job_status === 1 ? 'btn-danger' : 'btn-success'}`}
                  onClick={activateOrDeactivate}
                >
                  {selectedJob?.job_status === 1 ? 'Deactivate' : 'Activate'}
                </button>
              </div>
            )}
            {modalStatus === 'before-delete' && !isProcessing && (
              <div className="modal-footer border-top-0 justify-content-center">
                <button
                  type="button"
                  className="btn btn-outline-secondary px-4"
                  onClick={handleModalClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={`btn px-4 btn-danger`}
                  onClick={deleteJob}
                >
                  Delete
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const ManageJobs = () => {
  return (
    <>
      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">Manage Jobs</h2>
          <ul className="breadcrumb-menu">
            <li>
              <a href="index.html">Home</a>
            </li>
            <li className="active">Manage Jobs</li>
          </ul>
        </div>
        <div className="hero-shape">
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-1" src="assets/img/shape/03.svg" alt=""/>
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-2" src="assets/img/shape/05.svg" alt=""/>
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-3" src="assets/img/shape/06.svg" alt=""/>
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-4" src="assets/img/shape/07.svg" alt=""/>
        </div>
      </div> */}
      <Breadcrumb
        title="Manage Jobs"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Manage Jobs", active: true }
        ]}
      />
      <div className='user-profile py-120'>
        <div className='container'>
          <div className='row'>
            <EmployerDashboardNav />
            <PostedJobs />
          </div>
        </div>
      </div>
    </>
  )
}

export default ManageJobs
